import LoadingAnimation from "components/SharedComponents/LoadingAnimation";
import NavBar from "components/SharedComponents/navBar";
import Sidebar from "components/SharedComponents/SideBar";
import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { SearchContext } from "routes";
import { darkBackground } from "routes/darkBackground";
import { styles } from "./styles";
import { useCurrentSubscription } from "pages/settings/subscriptionView/hooks";

const AppLayout = () => {
  const classes = darkBackground();
  const layoutClasses = styles();
  const [searchTerm, setSearchTerm] = useState("");

  const { data: currentSub, isLoading: isSubscribedLoading } =
    useCurrentSubscription();

  const showBanner =
    !!currentSub &&
    !!currentSub.plusPlusCount &&
    !currentSub.subscribed &&
    !isSubscribedLoading;

  const hasReachedLimit =
    currentSub && currentSub.plusPlusCount >= currentSub.plusPlusTrialLimit;

  return (
    <div className={classes.mainContent}>
      <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
        <div
          className={layoutClasses.navContainer}
          style={{ height: showBanner ? "140px" : "90px" }}
        >
          {showBanner && (
            <div
              className={layoutClasses.trialBanner}
              style={{
                background: hasReachedLimit
                  ? "linear-gradient(135deg, #F13D58 0%, #FF8811 100%)"
                  : "linear-gradient(135deg, #FF8811 0%, #FFC107 100%)"
              }}
            >
              {currentSub.plusPlusCount < currentSub.plusPlusTrialLimit
                ? `You've reached ${currentSub.plusPlusCount} kudos. Please subscribe before reaching ${currentSub.plusPlusTrialLimit} kudos to continue using all our features.`
                : `You've reached  ${currentSub.plusPlusTrialLimit} kudos. Please Upgrade to unlock unlimited recognitions.`}
            </div>
          )}
          <NavBar
            showBanner={showBanner}
            navBarTitle="Hoya App"
            style={{ top: showBanner ? "50px" : "0px" }}
          />
        </div>
        <div className={classes.contentWrapper}>
          <Sidebar showBanner={showBanner} />
          <main className={layoutClasses.contentWrapper}>
            <div className={layoutClasses.appContent}>
              <Suspense fallback={<LoadingAnimation isLoading={true} />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </SearchContext.Provider>
    </div>
  );
};

export default AppLayout;
